<template>
  <div class="box-project" :class="{ 'show-box-shadow': showBoxShadow }" @click="submitButton(info.id)" >
    <slot name="img">
      <!-- <img src="@/assets/Rectangle 1114.png" alt="" /> -->
       <img v-complete:src="info.image" alt="" />
    </slot>
    <p class="box-p">
       {{ info.title }}
      <!-- 2024年高考真题命题分析与备考策略研究2024年高考真题命题分析与备考策略研究2024年高考真题命题分析与备考策略研究2024年高考真题命题分析与备考策略研究 -->
    </p>
    <slot name="Button"></slot>
  </div>
</template>

<script setup>
import { reactive } from "vue";
import { useRouter } from "vue-router";
import dayjs from "dayjs";

const router = useRouter();

const mydata = reactive({
  path: "",
  // 基础地址
  VUE_APP_BASE_HOST: process.env.VUE_APP_BASE_HOST,
});

const props = defineProps({
  // 是否显示阴影
  showBoxShadow: {
    type: Boolean,
    default: true,
  },

  path: {
    type: String,
    // default: "",
  },
  info: {
    type: Object,
    default: () => {
      return {};
    },
  },
});

//按钮点击事件
function submitButton(id) {
  router.push({
    path: props.path,
    query:{id}
  });
}



</script>

<style scoped lang="scss">


.box-project {
  width: 343px;
  // height:298px;
  // border:1px solid red;
  border-radius: 10px;
  background-color: #ffffff;
  
  box-shadow:2px 2px 4px #c5cbce90;
  overflow: hidden;

  cursor: pointer;

  > img {
    width: 100%;
    height: 201px;
    display: block;
    border-radius: 10px 10px 0px 0px;
    // cursor: pointer;
  }
  > p {
    // width:367px;
    margin: 16px;
    font-size: 16px;
    font-weight: 400;
    color: #333333;
    // color:red;
    min-height: 24px;
    line-height: 24px !important;
    display: -webkit-box;
    -webkit-box-orient: vertical; // 从上向下垂直排列子元素。设置或检索伸缩盒对象的子元素的排列方式 。
    text-overflow: ellipsis; //文本溢出 用省略号显示
    -webkit-line-clamp: 2; //几行
    overflow: hidden;
    // border:1px solid rgb(146, 38, 56);

    // cursor: pointer;
  }
   >p:hover {
      color: #009de0 !important;
      // font-weight: 550 !important;
    }
  .show-box-shadow {
    box-shadow: 0px 5px 40px 0px #0000000d;
  }
}
</style>